import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const ProgressBar = ({ percent }) => (
    <div className={styles.reactProgressBar}>
        <div className={styles.reactProgressBarPercent} style={{ width: `${percent}%` }} />
    </div>
)

ProgressBar.propTypes = {
    percent: PropTypes.number,
}

ProgressBar.defaultProps = {
    percent: -1,
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/features/Toaster/components/Toaster/components/ProgressBar/index.js